import script from "./AnnouncementImagePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementImagePicker.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementImagePicker.vue?vue&type=style&index=0&id=1e0413a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e0413a2"]])

export default __exports__